const contactPageLink =
  "https://www.everfox.com/products/content-disarm-reconstruction/application-extension-api-threat-protection#contact";

const outboundLinks = [contactPageLink];

module.exports = {
    contactPageLink,
    outboundLinks
}